import Service 			from "./../../Libs/Service";

let ProductFeed = new Service({

	Name: "ProductFeed",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		}

	},

	Actions: {

		// Получение базовой информации о списке товаров (serverId - нода, с которой пришли данные)
		"ProductFeed": function(productFeed, data, size, serverId) {

			this.setProductFeed(data.ProductFeed, data.ProductFeedCurrencies, data.ProductFeedCategories, serverId);

			Broadcast.call("Product Feed Loaded", [data.ProductFeed]);

		},

		"ProductFeedOffersError": function (error) {
			Broadcast.call("Product Feed Offers Error", [{message: error}]);
		},

		// Получение товаров по фильтру
		"ProductFeedOffers": function(productFeedOffers, data, size, serverId) {

			this.setProductFeedOffers(data.ProductFeed, data.ProductFeedOffers, serverId);

			Broadcast.call("Product Feed Offers Updated", [data.ProductFeedOffers]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id фидов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.feedsByServer = {};
		this.feedCurrenciesByServer = {};
		this.feedCategoriesByServer = {};
		this.feedOffersByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (feeds[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.feeds = this.getServerMap(this.feedsByServer, serverId);
		this.feedCurrencies = this.getServerMap(this.feedCurrenciesByServer, serverId);
		this.feedCategories = this.getServerMap(this.feedCategoriesByServer, serverId);
		this.feedOffers = this.getServerMap(this.feedOffersByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setProductFeed(productFeed, productFeedCurrencies, productFeedCategories, serverId) {

		if (!productFeed) return;

		serverId = serverId || this.NodeServerId;

		productFeed.additional_data = JSON.parse(productFeed.additional_data || '{}');

		this.getServerMap(this.feedsByServer, serverId)[productFeed.id] = productFeed;
		this.getServerMap(this.feedCurrenciesByServer, serverId)[productFeed.id] = productFeedCurrencies;
		this.getServerMap(this.feedCategoriesByServer, serverId)[productFeed.id] = productFeedCategories;

	},

	setProductFeedOffers(productFeed, productFeedOffers, serverId) {

		let feedOffers = this.getServerMap(this.feedOffersByServer, serverId || this.NodeServerId);

		if (!feedOffers[productFeed.id]) feedOffers[productFeed.id] = {};

		_.each(productFeedOffers, productFeedOffer => {

			feedOffers[productFeed.id][productFeedOffer["offer_id"]] = productFeedOffer;

		});

	},

	getFeedOfferImage(feedOffer) {

		return JSON.parse(feedOffer.images)[0];

	}

});

window.ProductFeed = ProductFeed;

export { ProductFeed }

